<script>
import appConfig from "@/app.config";
import Layout from "@/layouts/main.vue";
import GameCoverCard from "@/components/GameCoverCard.vue";
import GamesSwiper from "@/components/GamesSwiper.vue";
import Testimonials from "@/components/testimonials/Testimonials.vue";
// import Recommendation from "@/components/recommendation/Recommendation.vue";
import HelpSupport from "@/components/HelpSupport.vue";
import OurMissions from "@/components/OurMissions.vue";
import WaveLayer from "@/components/svg/waveLayer.vue";
import WaveLayerMobile from "@/components/svg/waveLayerMobile.vue";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import tool from "@/utils/tool";

export default {
  page: {
    title: "Home",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    GameCoverCard,
    GamesSwiper,
    // Testimonials,
    // Recommendation,
    HelpSupport,
    OurMissions,

    // WaveLayerMobile
  },
  data() {
    return {
      featureGame: [], // feature map
      randomList: [],
      assetsPath: appConfig.assetsPath,
      showLoadingScreen: true,
      showMobileWaveLayer: false,
      pageData: {},
      data: {
        learn: "/learn&play",
      },
      gamesSlideData: [
        {
          image: "game-photo-1@2x.jpg",
        },
        {
          image: "game-photo-2@2x.jpg",
        },
        {
          image: "game-photo-3@2x.jpg",
        },
        {
          image: "game-photo-4@2x.jpg",
        },
        {
          image: "game-photo-5@2x.jpg",
        },
        {
          image: "game-photo-6@2x.jpg",
        },
        {
          image: "game-photo-7@2x.jpg",
        },
      ],
      featuredCardData: [],
      swiperOption: {
        speed: 1500,
        slidesPerView: 4,
        centeredSlides: true,
        spaceBetween: 40,
        grabCursor: true,
        loop: true,

        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },

        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 20,
            width: 420,
          },
        },

        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
      },

      featuredGameOptions: {
        slidesPerView: 2,
        spaceBetween: 40,
        grabCursor: true,
        slidesPerGroup: 1,
        breakpoints: {
          1200: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: false,
            width: 1100,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: false,
            width: 930,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: false,
            width: 930,
          },
          600: {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            width: 400,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            width: 300,
          },
        },
      },
    };
  },
  methods: {
    getVideoUrl(url) {
      if (url) {
        if (url.indexOf("http") > -1) {
          return url;
        }
        return this.assetsPath + url + ".mp4";
      }
      return "";
    },
    languageChanged(value) {
      this.data = this.pageData.data[value];
      this.gameList = this.gameData.data[value].list;
      const gameData = this.gameList.filter((element) => element.isOpen);
      this.randomList = tool.getRandomList(gameData, this.pageData, 3);
      let featureGame = [];
      Object.keys(this.gameData.data[value].featureGame).forEach((key) => {
        featureGame.push(this.gameData.data[value].featureGame[key]);
      });
      if (value === "zh") {
        featureGame = [
          {
            title: "书山课外读",
            abstract:
              "书山课外读是一款中文分级阅读APP，紧贴课纲要求，让孩子在AI与游戏化辅助下掌握阅读技巧",
            route: "",
            cover:
              "https://cdn01.xiongmaoboshi.com/asset/img/ss-bg.png",
            logo: "https://cdn01.xiongmaoboshi.com/asset/img/ss-logo.png",
            link: "",
          }
        ]
        Object.keys(this.gameData.data[value].featureGame).forEach((key) => {
          featureGame.push(this.gameData.data[value].featureGame[key]);
        });

        featureGame.push({
          title: "ABC Reading同步练",
          abstract:
            "专为小学生打造的英语课后练习软件，教材配套搭配AI老师，帮你更快进步！",
          route: "",
          cover:
            "https://preview-web.xiongmaoboshi.com/resource/cms/image/tbbanner.png",
          logo: "https://preview-web.xiongmaoboshi.com/resource/cms/image/abctb.png",
          link: "",
        }); // ABC Reading同步练

        featureGame.push({
          title: "熊猫博士 ABC Reading",
          abstract:
            "经典儿童阅读绘本，RAZ独家授权",
          route: "http://abctime.com/",
          cover:
            "https://cdn01.xiongmaoboshi.com/asset/img/abcc-1647500751874-112.png",
          logo: "https://cdn01.xiongmaoboshi.com/asset/img/AppStore@1x (1)-1647500751883-447.png",
          link: "http://abctime.com/",
        }); //加上ABC

      }
      featureGame.reverse();
      const index = featureGame.findIndex(item => item.route === "learn&play")
      if (index > -1) {
        featureGame[index].title = '熊猫博士A-Z Words'
        featureGame[index].abstract = '快乐学英语'
        featureGame[index].logo = 'https://business.xiongmaoboshi.com/asset/img/dkicon-1699934079917-331.png'
        featureGame[index].videoUrl = 'https://business.xiongmaoboshi.com/asset/video/dkvideo-1699934095634-80.mp4'
      }
      this.featureGame = [...featureGame];
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 300);
    },
    checkDevice() {
      this.isMobile = window.innerWidth < 768;
      if (this.isMobile) {
        this.showMobileWaveLayer = true;
      }
    },
    gspLoad() {
      gsap.registerPlugin(ScrollTrigger);
      gsap.defaults({ duration: 2 });
      const tl = gsap.timeline();
      tl.to("#videoPlayer", { opacity: 0 });

      ScrollTrigger.create({
        animation: tl,
        trigger: "#featuredSection",
        start: "0 0",
        end: "+=500",
        scrub: 0.8,
      });
    },
  },
  created: function () {
    // console.log(this.gamesSlideData, "有东西不？");
    this.GLOBAL.addEventListener("languageChanged", this.languageChanged);
    this.pageData = window.pageData;
    this.gameData = window.gamesData;
    window.scrollTo(0, 0);
  },
  mounted() {
    window.addEventListener("resize", this.checkDevice, { passive: true });
    this.featuredCardData = this.$t("home.featuredCardData");
    //this.loadLocaleMessages(this.$i18n.locale)
    this.scrollToTop();
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.showLoadingScreen = false;
        this.scrollToTop();
        this.gspLoad();
      }
    };
    this.checkDevice();
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.checkDevice, { passive: true });
    }
  },
  updated() {
    this.featuredCardData = this.$t("home.featuredCardData");
  },
};
</script>

<template>
  <Layout :showLoadingScreen="showLoadingScreen" page="home">
    <div :class="$style.homeHero" class="d-inline-block w-100">
      <div :class="$style.videoPlayer" id="videoPlayer">
        <video width="320" height="240" muted autoplay loop playsinline
          :poster="assetsPath + 'images/home-background@2x.png'">
          <source :src="data.videoUrl
            ? getVideoUrl(data.videoUrl)
            : assetsPath + 'home-video.mp4'
            " type="video/mp4" />
          <source :src="assetsPath + 'home-video.webm'" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div :class="$style.waveLayerBlock">
        <!-- <WaveLayerMobile v-if="showMobileWaveLayer"/>
        <img :src="assetsPath + 'images/wave-fill-layer.svg'" :class="$style.waveLayer" v-else> -->
      </div>
      <!-- <WaveLayer /> -->

      <div :class="$style.heroContent">
        <h1>{{ $t("home.meet") }}</h1>
        <p class="mb-md-0 mb-lg-0 mb-xl-0">
          {{ $t("home.meetDetail") }}
        </p>
        <!-- <p class="d-none d-md-inline-block d-lg-inline-block d-xl-inline-block">
          {{ $t("home.meetDetail2")}}
        </p> -->
        <!-- <img src="@/assets/images/icons/play-button.svg" /> -->
      </div>
      <div :class="$style.bottomPanda">
        <img :src="assetsPath + 'images/DrPanda.svg'" />
      </div>
    </div>

    <div class="bg-offWhite d-inline-block w-100" :class="$style.featuredSection" id="featuredSection">
      <div class="d-inline-block w-100">
        <h2 class="text-center d-inline-block w-100 heading-2 mb-0" :class="$style.fHeading">
          {{ $t("home.featured") }}
        </h2>

        <div :class="$style.featuredBlock" class="w-100 d-inline-block">
          <div :class="$style.blogBlock" class="d-flex flex-column w-100 bg-lightYellow">
            <b-container>
              <div :class="$style.setOnTop">
                <b-row align-h="center">
                  <b-col v-for="(data, index) in featureGame" :key="index" class="mb-4" cols="12" sm="12" md="6" lg="6"
                    xl="6">
                    <GameCoverCard :data="data" class="mb-1" />
                  </b-col>
                </b-row>
              </div>
            </b-container>
          </div>
          <div :class="$style.gamesCardBlock">
            <div class="d-flex flex-column w-100 bg-lightYellow">
              <GamesSwiper :gameDataProps="gamesSlideData" :swiperOption="swiperOption" swiperStartSlide="1" />
            </div>
          </div>
          <div :class="$style.exploreBtn">
            <b-container>
              <div class="d-flex justify-content-center align-items-center">
                <!-- <button
                  @click="GLOBAL.routetrGo('games')"
                  type="button"
                  class="btn btn-primary btn-x max-w-100 mw-100"
                >
                  {{ $t("home.explore") }}
                </button> -->
              </div>
            </b-container>
          </div>
        </div>
      </div>
      <OurMissions />
      <div :class="$style.awardBlock">
        <b-container>
          <div :class="$style.setCenter">
            <h2 class="heading-2 text-center">{{ $t("home.awards") }}</h2>
            <p class="text-center l-h-28 paragraph">
              {{ $t("home.awardDesp") }}
            </p>
            <div :class="$style.awardContent" class="d-flex flex-column flex-md-row justify-content-center">
              <div class="w-100">
                <img :src="assetsPath + 'images/awards-panda@2x.png'" class="w-100" />
              </div>
              <ul>
                <li class="
                    d-flex
                    flex-row
                    align-items-center
                    justify-content-center
                  ">
                  <div :class="$style.badge">
                    <img :src="assetsPath + 'images/smartmedia@2x.png'" class="w-100" />
                  </div>
                  <div v-html="$t('home.award1')" />
                </li>
                <li class="
                    d-flex
                    flex-row
                    align-items-center
                    justify-content-center
                  ">
                  <div :class="$style.badge">
                    <img :src="assetsPath + 'images/national-award-winnder@2x.png'" class="w-100" />
                  </div>
                  <p>{{ $t("home.award2") }}</p>
                </li>
                <li class="
                    d-flex
                    flex-row
                    align-items-center
                    justify-content-center
                  ">
                  <div :class="$style.badge">
                    <img :src="assetsPath + 'images/educational-certified@2x.png'" class="w-100" />
                  </div>
                  <p>{{ $t("home.award3") }}</p>
                </li>
              </ul>
            </div>
          </div>
        </b-container>
      </div>
      <!-- <div
        :class="$style.testimonials"
        v-if="data.testimonials && data.testimonials.length > 0"
        class="w-100 d-inline-block"
      >
        <Testimonials :testimonials="data.testimonials" />
      </div> -->
      <div class="w-100 d-inline-block">
        <!-- <Recommendation :recommendation="randomList" /> -->
      </div>
      <div class="w-100 d-inline-block">
        <HelpSupport />
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.homeHero {
  float: left;
  position: relative;
  height: 70vh;
  //background-image: url("https://images.pexels.com/photos/3192801/pexels-photo-3192801.jpeg?crop=entropy&cs=srgb&dl=pexels-aaron-burden-3192801.jpg&fit=crop&fm=jpg&h=2989&w=3989");
  //background-image: url("~@/assets/images/home-background@2x.png");
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;

  .videoPlayer {
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    float: left;
    z-index: -1;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &:before {
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      background-color: rgba(0, 0, 0, 0);
      z-index: 1;
    }
  }
}

.heroContent {
  position: absolute;
  width: 730px;
  height: 227px;
  max-width: 100%;
  margin: auto;
  color: $white;
  z-index: 2;
  top: -100px;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;

  h1 {
    color: $white;
    font-size: 48px;
    margin-bottom: 30px;
  }

  p {
    font-size: 20px;
    margin-bottom: 40px;
  }
}

.bottomPanda {
  position: absolute;
  bottom: -50px;
  right: 0;
  left: 0;
  margin: 0 auto;
  width: 332px;
  z-index: 2;
}

.fHeading {
  margin-top: 67px;
  position: relative;
  z-index: 1;
}

.featuredBlock {
  margin-top: 60px;
  position: relative;
  z-index: 1;
}

.gamesCardBlock {
  margin-top: 56px;
  background-color: pink;
}

.gameList {
  margin-top: 116px;
}

.exploreBtn {
  margin-top: 42px;
  margin-bottom: 40px;
}

.featuredSection {
  padding-top: 50px;
}

.awardBlock {
  background-color: $light-yellow;
  padding-top: 30px;
  padding-bottom: 10px;

  .setCenter {
    width: 820px;
    margin: 0 auto;
    max-width: 100%;
  }

  h2 {
    margin-bottom: 30px;
  }

  .paragraph {
    width: 730px;
    margin: 0 auto;
    max-width: 100%;
  }

  .awardContent {
    margin-top: 60px;

    ul {
      padding: 0;
      min-width: 355px;

      li {
        width: 100%;
        position: relative;
        padding-left: 125px;
        background-color: $white;
        border-radius: 14px;
        margin-bottom: 20px;
        height: 128px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

        >.badge {
          position: absolute;
          left: 25px;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 80px;
          height: 80px;

          img {
            max-height: 100%;
          }
        }

        p {
          font-family: $family-bold;
          margin-bottom: 0;
        }
      }
    }
  }
}

.waveLayerBlock {
  display: block;
  position: absolute;
  width: 100%;
  height: 16.12127vw;
  left: 0;
  bottom: -2px;
  z-index: 2;
  background-image: url("#{$assetsPath}images/intro/wave-new.svg");
  background-size: 100% 100%;

  .waveLayer {
    position: absolute;
    bottom: -400px;
    left: -5px;
    right: 0;
    margin: auto;
    width: 101%;
    max-width: 101%;
    z-index: 1;
  }
}

@media only screen and (max-width: 767px) {
  .homeHero {
    height: 80vh;
    margin-bottom: 0;
    float: left;
  }

  .heroContent {
    padding: 0 30px;
  }

  .featuredSection {}

  .bottomPanda {
    bottom: -100px;
  }

  .gamesCardBlock {
    margin-top: 40px;
  }

  .exploreBtn {
    margin-top: 40px;
  }

  .awardBlock {
    .awardContent {
      margin-top: 27px;

      ul {
        min-width: auto;
        width: 100%;
        margin-top: -140px;
      }
    }
  }

  .featuredBlock {
    .featuredCard {
      margin-left: 20px;
    }
  }
}

@media only screen and (max-width: 575px) {
  .awardBlock {
    .awardContent {
      ul {
        margin-top: -30%;
      }
    }
  }
}

@media only screen and (max-height: 400px) {
  .bottomPanda {
    bottom: -160px;
  }
}
</style>
